<template>
  <div>
    <div class="with-wrap">
      <div class="top">
        <div class="title">成功撤回</div>
        <div class="time">撤回时间：{{ time }}</div>
      </div>
      <div class="header">
        <div class="name flexCenterBetween">
          <div class="flexCenterBetween">
            <img :src="info.avatar" alt="" />{{ info.name }}
          </div>
        </div>
        <div class="com-item">
          <div class="l">投诉金额：</div>
          <div class="r">¥{{ info.fee }}</div>
        </div>
        <div class="com-item">
          <div class="l">投诉时间：</div>
          <div class="r">{{ info.t_create }}</div>
        </div>
        <div class="com-item">
          <div class="l">联系方式：</div>
          <div class="r">{{ info.phone }}</div>
        </div>
        <div
          class="com-item"
          :style="{
            paddingBottom: info.imgs && info.imgs.length ? '' : '15px'
          }"
        >
          <div class="l">投诉原因：</div>
          <div class="r">{{ info.appeal_desc }}</div>
        </div>
        <div class="com-item" v-if="info.imgs && info.imgs.length">
          <div class="l">证据截图：</div>
          <div class="r">
            <div class="img-box">
              <img
                @click="previewImage(index)"
                :src="item"
                v-for="(item, index) in info.imgs"
                :key="index"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" @click="back()">
      <div class="btn l">回到订单列表</div>
    </div>
  </div>
</template>
<script>
import { formatDate } from "@/utils/common";
export default {
  data() {
    return {
      time: "",
      info: {}
    };
  },
  methods: {
    back() {
      if( /miniProgram/i.test(window.navigator.userAgent)) { // 如果是嵌套在小程序里面
        let data = {orderRefresh: true};
        wx.miniProgram.postMessage({
          data
        });
        let delta = 2;
        if(localStorage.getItem('orderDirect') == 1) {
          delta = 1
        }
        wx.miniProgram.navigateBack({
          delta
        });
      }else {
        this.$router.go(-1)
      }
    }
  },
  mounted() {
    document.title = '撤回'
    this.time = formatDate(
      new Date().getTime(),
      "yyyy-MM-dd HH:mm"
    );
    this.info = JSON.parse(localStorage.getItem("complainData"));
  }
};
</script>
<style lang="scss" scoped>
.with-wrap {
  margin: 10px 15px;
}
.top {
  background: #ffffff;
  padding: 15px;
  border-radius: 4px;
  .title {
    font-size: 17px;
    font-weight: bold;
  }
  .time {
    font-size: 14px;
    color: #999999;
    margin-top: 5px;
  }
}
.header {
  background: #ffffff;
  padding: 15px 15px 0;
  margin-top: 10px;
  border-radius: 4px;
}
.name {
  height: 30px;
  font-size: 14px;
  margin-bottom: 15px;
  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
  }
  .r {
    font-size: 13px;
    color: #999999;
  }
}
.com-item {
  display: flex;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 10px;
  position: relative;
  .l {
    color: #999999;
    min-width: 70px;
  }
  .r {
    flex: 1;
  }
  .no-img {
    color: #999999;
  }
}
.img-box {
  display: flex;
  flex-wrap: wrap;
  img {
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 15px;
  }
}
.com-item:last-child {
  margin-bottom: 0;
}
.foot {
  left: auto;
  max-width: 500px;
  min-width: 320px;
  padding: 10px 15px;
  background: #ffffff;
  border-top: 1px solid #eee;
  display: flex;
  box-sizing: border-box;
  cursor: pointer;
  .btn {
    flex: 1;
    border-radius: 4px;
    height: 45px;
    background: #F6F6F6;
    color: #666666;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/withdraw.vue